<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :style="{
      width: width + 'px',
      height: height + 'px',
      fill: color
    }"
  >
  <use xlink:href="/images/good.svg#good"></use>
  </svg>
</template>

<script>
export default {
  name: 'TwitterXIcon',
  props: {
    color: {
      type: String,
      default: '#fff'
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 15
    }
  }
}
</script>